require("typeface-josefin-sans")
require("typeface-merriweather")
require("typeface-amatic-sc")

exports.shouldUpdateScroll = () => {
  return false
}
